import type { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AddIcon from '@mui/icons-material/Add';
import { FilterGroup } from '../components';
import useFilterStore from '../hooks/useFilterStore';
import useRulePageMode from '../hooks/useRulePageMode';
import { isEmpty } from 'lodash-es';

const GoogleFilterGroupsContainer: FC = observer(() => {
  const { isRead } = useRulePageMode();
  const filterStore = useFilterStore();

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" sx={{ mr: 3 }}>
          Filters
        </Typography>
        {!isEmpty(filterStore.filterGroups) && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <InfoOutlinedIcon sx={(t) => ({ color: t.palette.primary.main, fontSize: t.typography.body2.fontSize })} />
            <Typography variant="caption">Filter groups have “OR” relation</Typography>
          </Box>
        )}
      </Box>
      <Box>
        {filterStore.filterGroups.map((fg, i) => (
          <FilterGroup key={i} groupIndex={i} group={fg} />
        ))}
      </Box>
      {!isRead && (
        <Box sx={{ py: 2.5 }}>
          <Button
            onClick={() => {
              filterStore.addFilterGroup();
            }}
          >
            <AddIcon sx={{ mr: 1 }} /> Add filter group
          </Button>
        </Box>
      )}
    </Box>
  );
});

export default GoogleFilterGroupsContainer;
